import ADVISOR_CLEAN_FILTER_ICON from '../assets/icons/advisor/clean_filter_icon.svg';
import ALERT_RED_ICON from '../assets/icons/alert/ic_alert.svg';
import ARROW_DOWN from '../assets/icons/arrow/arrow-down.svg';
import CHECK_ICON_ALT from '../assets/icons/check/check_icon_alt.svg';
import CHECKMARK from '../assets/icons/check/checkmark.svg';
import DOUBLE_CHECK from '../assets/icons/check/double_check.svg';
import DRAG_AND_DROP_ICON from '../assets/icons/dragAndDrop/drag_and_drop_icon.svg';
import BLACK_LENS from '../assets/icons/emptyState/black_lens.svg';
import BULB from '../assets/icons/emptyState/bulb.svg';
import CLOUD_NO_DATA_RECOMMENDED_OCCUPATIONS from '../assets/icons/emptyState/cloud-no-data-recommended-occupations.svg';
import CONVERSATION_CHAT from '../assets/icons/emptyState/conversation_chat.svg';
import EARTH_SEARCH_PAGE404 from '../assets/icons/emptyState/earthSearchPage404.svg';
import EMPTY_STATE_MAJORS from '../assets/icons/emptyState/empty-state-majors.svg';
import EMPTY_STATE_COURSE_ADVISOR from '../assets/icons/emptyState/empty_state_courses_advisor.svg';
import EMPTY_STATE_EXPLORE_SKILLS_ADVISOR from '../assets/icons/emptyState/empty_state_explore_skills_advisor.svg';
import EMPTY_STATE_RECOMMENDATION from '../assets/icons/emptyState/empty_state_recommendation.svg';
import EMPTY_STATE_SELECT_OCCUPATION from '../assets/icons/emptyState/empty_state_select_occupation.svg';
import HOUR_GLASS_ICON from '../assets/icons/emptyState/hourglass_icon.svg';
import CIRCLE_NONE from '../assets/icons/emptyState/ic_remove.svg';
import LENS_MEDIUM_GRAY from '../assets/icons/emptyState/lens_medium_gray.svg';
import LIGHT_BULB from '../assets/icons/emptyState/light_bulb_shine.svg';
import NO_COURSES_EMPTY from '../assets/icons/emptyState/noCoursesEmptyState.svg';
import NO_DATA_CLOUD_ICON from '../assets/icons/emptyState/noDataCloud.svg';
import NO_DATA_CLOUD_ICON_BIG from '../assets/icons/emptyState/noDataCloudIconBig.svg';
import RED_ICON_SKILL_SET_REQUIRED from '../assets/icons/emptyState/red-icon-skill-set-required.svg';
import SEARCH_FILES from '../assets/icons/emptyState/search_files.svg';
import LOCK_ICON from '../assets/icons/emptyState/streamline_icon_lock.svg';
import ERROR_ICON_CARD from '../assets/icons/errorState/error_icon_card.svg';
import ERROR_ICON_LARGE from '../assets/icons/errorState/error_icon_carousel.svg';
import EXPAND_ARROWS from '../assets/icons/expand/expand_icon_black.svg';
import EXPAND_ICON from '../assets/icons/expand/expand_icon_grey.svg';
import FAVICON from '../assets/icons/favicon/favicon.svg';
import FAVICON_ADVISOR from '../assets/icons/favicon/faviconAdvisor.svg';
import FAVICON_LEARNER from '../assets/icons/favicon/faviconLearner.svg';
import FILTER_ICON from '../assets/icons/filter/filter_icon.svg';
import INFO_ICON from '../assets/icons/info/info_icon.svg';
import CIRCULAR_LOADER_DARK from '../assets/icons/loader/circular_loader_dark.png';
import CIRCULAR_LOADER_LIGHT from '../assets/icons/loader/circular_loader_light.png';
import LOGIN_1MENTOR from '../assets/icons/logo/1M_logo_login.svg';
import BLACK_LOGO from '../assets/icons/logo/BlackLogo.svg';
import LEARNER_WHITE_LOGO from '../assets/icons/logo/learner_white_logo.svg';
import LOGIN_UVA from '../assets/icons/logo/login_uva.svg';
import LIGHT_BULB_NOTIFICATION from '../assets/icons/notification/light_bulb.svg';
import THUMBS_UP_NOTIFICATION from '../assets/icons/notification/like_shine.svg';
import PERFORMANCE_INCREASE_ICON from '../assets/icons/notification/performance-increase.svg';
import PERFORMANCE_DOWN_ICON_NEW from '../assets/icons/notification/performance_down_icon_new.svg';
import MAP_PIN_OCCUPATION from '../assets/icons/occupation/map_pin.svg';
import BOOKMARK_OUTLINED_LARGE from '../assets/icons/other/bookmark_outlined_large.svg';
import BOOKMARK_OUTLINED_SMALL_MEDIUM from '../assets/icons/other/bookmark_outlined_small_medium.svg';
import DEFAULT_UNIVERSITY_AVATAR from '../assets/icons/other/DefaultUniversityAvatar.svg';
import FILL_POSITION_ICON from '../assets/icons/other/fillPosition_icon.svg';
import GRADUATE_CAP from '../assets/icons/other/graduate_cap.svg';
import HIGH_DEMAND from '../assets/icons/other/high_demand.svg';
import CAREER_TRENDS from '../assets/icons/other/ic_career_trends.svg';
import CONTACT_ICON from '../assets/icons/other/ic_contact.svg';
import COURSES_ICON from '../assets/icons/other/ic_courses.svg';
import FAQ_ICON from '../assets/icons/other/ic_faq.svg';
import INSIGHTS_ICON from '../assets/icons/other/ic_insights.svg';
import LOVE_STAR_ICON from '../assets/icons/other/ic_love_it_star.svg';
import MORE_HORIZONTAL_ICON from '../assets/icons/other/ic_more_hoz.svg';
import EMPTY_STATE_CAREER_TRENDS from '../assets/icons/other/ic_school.svg';
import STUDENT_OVERVIEW_ICON from '../assets/icons/other/ic_student_overview.svg';
import INTERSECT from '../assets/icons/other/intersect.svg';
import JOB_ICON from '../assets/icons/other/job_icon.svg';
import JOB_ICON_CHECK from '../assets/icons/other/job_responsibility_bag_check.svg';
import LAPTOP_IDEA from '../assets/icons/other/laptop_idea.svg';
import LEARNING_ICON from '../assets/icons/other/learning_icon.svg';
import LENS_MEDIUM from '../assets/icons/other/lens_medium.svg';
import LOGOUT_ICON from '../assets/icons/other/logout_icon.svg';
import LOW_DEMAND from '../assets/icons/other/low_demand.svg';
import PASSWORD_ICON from '../assets/icons/other/password_icon.svg';
import PENCIL_BLACK from '../assets/icons/other/pencil_black.svg';
import PROFILE_ICON from '../assets/icons/other/profile_icon.svg';
import READING_ICON from '../assets/icons/other/reading_icon.svg';
import REQUIRE_SKILL_ICON from '../assets/icons/other/requireSkill_icon.svg';
import ROCKET_CREATE_PATH from '../assets/icons/other/rocket_create_path.svg';
import SEARCH_STAR_ICON from '../assets/icons/other/search_star.svg';
import SKILL_MODAL_STATUS from '../assets/icons/other/skill_modal_status.svg';
import DEFAULT_PROVIDER from '../assets/icons/provider/default.svg';
import BOOKMARK_CONTAINED from '../assets/icons/sidebar/bookmark_contained.svg';
import BOOKMARK_OUTLINED from '../assets/icons/sidebar/bookmark_outlined.svg';
import ICON_TRASH from '../assets/icons/trash/iconTrash.svg';
import REMOVED_SKILL_TRASH from '../assets/icons/trash/removed_skill_trash.svg';
import TRASH_BLACK from '../assets/icons/trash/trash_black.svg';
import TRASH_ICON_PINK from '../assets/icons/trash/trash_icon_pink.svg';
import WHITE_TRASH_ICON from '../assets/icons/trash/white_trash.svg';

const DEFAULT_ICON_WORD = 'default';

export default {
  ADVISOR_CLEAN_FILTER_ICON,
  ALERT_RED_ICON,
  ARROW_DOWN,
  BULB,
  CHECK_ICON_ALT,
  CHECKMARK,
  DOUBLE_CHECK,
  CLOUD_NO_DATA_RECOMMENDED_OCCUPATIONS,
  EARTH_SEARCH_PAGE404,
  EMPTY_STATE_COURSE_ADVISOR,
  EMPTY_STATE_EXPLORE_SKILLS_ADVISOR,
  EMPTY_STATE_RECOMMENDATION,
  EMPTY_STATE_SELECT_OCCUPATION,
  ERROR_ICON_LARGE,
  ERROR_ICON_CARD,
  NO_COURSES_EMPTY,
  NO_DATA_CLOUD_ICON,
  NO_DATA_CLOUD_ICON_BIG,
  EMPTY_STATE_MAJORS,
  RED_ICON_SKILL_SET_REQUIRED,
  EXPAND_ARROWS,
  EXPAND_ICON,
  FAVICON,
  EMPTY_STATE_CAREER_TRENDS,
  FAVICON_ADVISOR,
  FAVICON_LEARNER,
  FILTER_ICON,
  INFO_ICON,
  LEARNER_WHITE_LOGO,
  PERFORMANCE_INCREASE_ICON,
  DEFAULT_UNIVERSITY_AVATAR,
  CONTACT_ICON,
  COURSES_ICON,
  FAQ_ICON,
  INSIGHTS_ICON,
  CAREER_TRENDS,
  LOVE_STAR_ICON,
  MORE_HORIZONTAL_ICON,
  STUDENT_OVERVIEW_ICON,
  JOB_ICON,
  LOGOUT_ICON,
  PASSWORD_ICON,
  PROFILE_ICON,
  READING_ICON,
  SEARCH_STAR_ICON,
  SKILL_MODAL_STATUS,
  DEFAULT_PROVIDER,
  ICON_TRASH,
  REMOVED_SKILL_TRASH,
  TRASH_ICON_PINK,
  WHITE_TRASH_ICON,
  FILL_POSITION_ICON,
  LEARNING_ICON,
  REQUIRE_SKILL_ICON,
  BLACK_LOGO,
  PERFORMANCE_DOWN_ICON_NEW,
  BLACK_LENS,
  HOUR_GLASS_ICON,
  CONVERSATION_CHAT,
  LIGHT_BULB,
  CIRCLE_NONE,
  SEARCH_FILES,
  PENCIL_BLACK,
  TRASH_BLACK,
  ROCKET_CREATE_PATH,
  LOGIN_UVA,
  CIRCULAR_LOADER_LIGHT,
  CIRCULAR_LOADER_DARK,
  DRAG_AND_DROP_ICON,
  JOB_ICON_CHECK,
  INTERSECT,
  LIGHT_BULB_NOTIFICATION,
  THUMBS_UP_NOTIFICATION,
  DEFAULT_ICON: DEFAULT_ICON_WORD,
  BOOKMARK_OUTLINED,
  BOOKMARK_CONTAINED,
  LAPTOP_IDEA,
  BOOKMARK_OUTLINED_LARGE,
  BOOKMARK_OUTLINED_SMALL_MEDIUM,
  GRADUATE_CAP,
  LOGIN_1MENTOR,
  HIGH_DEMAND,
  LOW_DEMAND,
  LENS_MEDIUM,
  LENS_MEDIUM_GRAY,
  LOCK_ICON,
  MAP_PIN_OCCUPATION,
};
